import { useEffect } from 'react';

import { useStore } from 'models/Provider';

export const useJobBoards = () => {
  const { jobboardStore } = useStore();
  useEffect(() => {
    jobboardStore.load();
  }, [jobboardStore]);
  return jobboardStore;
};
